import React from 'react'
import BackgroundOptions from '../../dialogs/EditPresentationSectionDialog/BackgroundOptions'

export default function SocialBackgroundOptions() {
  return <BackgroundOptions allowAlignOptions allowPaddingOptions />
}
